import Vue from 'vue';
export default Vue.extend({
    name: 'Linkify',
    props: {
        text: {
            type: String,
            required: true,
        },
    },
    filters: {
        linkURL(text) {
            const MARKDOWN_URL_REGEX = /(\[(.*?)\])\((.*?)\)/gm;
            const PLAIN_URL_REGEX = /((https?:\/\/)?[\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?[^\s,.]+)/gm;
            if (MARKDOWN_URL_REGEX.test(text)) {
                return text.replace(MARKDOWN_URL_REGEX, (_match, _p1, p2, p3) => p2 && p3
                    ? `<a href="${p3}" target="_blank" rel="noopener noreferrer" class="linkify">${p2}</a>`
                    : text);
            }
            else if (PLAIN_URL_REGEX.test(text)) {
                return text.replace(PLAIN_URL_REGEX, '<a href="$1" target="_blank" rel="noopener noreferrer" class="linkify">$1</a>');
            }
            else {
                return text;
            }
        },
    },
});
